var map = {
	"./de.js": [
		"BpkI",
		10
	],
	"./en.js": [
		"AkSj",
		11
	],
	"./fr.js": [
		"UHev",
		12
	],
	"./it.js": [
		"PeP/",
		13
	],
	"./ja.js": [
		"LPye",
		14
	],
	"./ru.js": [
		"sR4o",
		15
	],
	"./tr.js": [
		"r799",
		16
	],
	"./zh.js": [
		"YJMR",
		17
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "PKrk";
module.exports = webpackAsyncContext;